import { URL } from "../environment/variables";

export const getInfoTextService = async () => {

    try{
        const response = await fetch(`${URL}/cms/obtenerconfiguraciones/B7FE92D3-C914-48D3-881F-BE987B567745`, {
            mode: 'cors',
            method: 'GET',
            headers:{
                'Accept': '*/*',
            }
        })
        const json = await response.json()
        return json
    }catch(err){
        console.log(err)
    }

}